<template>
  <div class="row">
    <app-modal id="modal-manifiesto"
               :title="modalTitle"
               :comp="modalComponent"
               :data="modalData"
               :size="modalSize"
               :scroll="true"
               :hideClose="false"
               @autorizacion="enviar($event)"></app-modal>

    <img src="static/img/encabezado.png" alt="declaraNet">
    <div class="col-md-12 card card-wizard">
      <div class="card-header">
        <div class="text-center">
        </div>
        <p class="category text-right fechap">{{ fecha }}</p>
        <p class="category text-right">{{ hora }}</p>
      </div>

      <div class="container">
        <div class="row">
          <div class="col">
            <h4 class="title text-center">Vista previa de la declaración patrimonial y de intereses</h4>
          </div>
        </div>
        <div class="row border-top">
          <div class="col">
            <h5 class="nombreUpc">{{ this.dpersonales.nombres }}</h5>
          </div>
        </div>
        <div class="row border-top">
          <div class="col">
            <h5>{{ this.encargo.dependencia }}</h5>
          </div>
        </div>
        <div class="row border-top">
          <div class="col bk">
            <div class="categoria">Datos Personales</div>
          </div>
        </div>
        <div class="row border-top">
          <div class="col">
            <p class="datosOtros">{{ this.dpersonales.nombres.toUpperCase() }}</p>
            <p class="datosOtros">{{ this.dpersonales.curp }}</p>
            <p class="datosOtros">{{ this.dpersonales.rfc }}</p>
          </div>
        </div>
        <div class="row border-top">
          <div class="col bk">
            <div class="categoria">Datos Curriculares</div>
          </div>
        </div>
        <div class="row border-top">
          <div class="col">
            <div v-for="(item, i) in curriculares" :key="'dc' + i">
              <div class="mb-2" :class="{ btop: (i > 0) }">
                <p class="datosOtros">{{ item.grado }}</p>
                <p class="datosOtros">{{ item.institucion }}</p>
                <p class="datosOtros">{{ item.carrera }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row border-top">
          <div class="col bk">
            <div class="categoria">Experiencia Laboral</div>
          </div>
        </div>
        <div class="row border-top">
          <div class="col">
            <div v-for="(item, i) in experiencia" :key="'elab' + i">
              <div :class="{ btop: (i > 0) }">
                <p class="datosOtros">{{ item.ambito }}</p>
                <p class="datosOtros">{{ item.institucion }}</p>
                <p class="datosOtros">{{ item.unidad }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row border-top">
          <div class="col bk">
            <div class="categoria">Datos del Encargo Actual</div>
          </div>
        </div>
        <div class="row border-top">
          <div class="col">
            <div>
              <p class="datosOtros">{{ this.encargo.dependencia.toUpperCase() }}</p>
              <p class="datosOtros">{{ this.encargo.cargo.toUpperCase() }}</p>
            </div>
          </div>
        </div>
        <div class="row border-top">
          <div class="col bk">
            <div class="categoria">Datos del cónyuge, concubina, concubinario y/o dependientes económicos</div>
          </div>
        </div>
        <div class="row border-top">
          <div class="col">
            <div v-for="(dependiente, i) in dependientes" :key="'dep' + i" :class="{ btop: (i > 0) }">
              <p class="datosOtros">{{ dependiente.nombre.toUpperCase() }}</p>
              <p class="datosOtros">{{ dependiente.relacion.toUpperCase() }}</p>
            </div>
            <div v-if="dependientes.length == 0">
              <p class="datosOtros">NO</p>
            </div>
          </div>
        </div>
        <div class="row border-top">
          <div class="col">
            <div class="row border-top">
              <div class="col bk">
                <div class="categoria">Intereses</div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div class="categoria padd">Empresas, Sociedades y Asociaciones</div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div v-for="(empresas, i) in intereses.empresas" :key="'emp' + i">
                  <div :class="{ btop: (i > 0) }">
                    <p class="datosOtros">{{ empresas.nombreEmpresa.toUpperCase() }}</p>
                    <p class="datosOtros">{{ empresas.naturaleza.toUpperCase() }}</p>
                  </div>
                </div>
                <div v-if="intereses.empresas.length == 0">
                  <p class="datosOtros">NO</p>
                </div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div class="categoria padd">Participación en Toma de Decisiones</div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div v-for="(empresas, i) in intereses.tomaDecisiones" :key="'emps' + i">
                  <div :class="{ btop: (i > 0) }">
                    <p class="datosOtros">{{ empresas.nombre.toUpperCase() }}</p>
                    <p class="datosOtros">{{ empresas.puesto.toUpperCase() }}</p>
                  </div>
                </div>
                <div v-if="intereses.tomaDecisiones.length == 0">
                  <p class="datosOtros">NO</p>
                </div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div class="categoria padd">Beneficios Públicos</div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div v-for="(empresas, i) in intereses.beneficiosPubl" :key="'bene' + i" :class="{ btop: (i > 0) }">
                  <p class="datosOtros">{{ empresas.programa.toUpperCase() }}</p>
                  <p class="datosOtros">{{ empresas.institucion.toUpperCase() }}</p>
                </div>
                <div v-if="intereses.beneficiosPubl.length == 0">
                  <p class="datosOtros">NO</p>
                </div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div class="categoria padd">Representación</div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div v-for="(empresas, i) in intereses.reprActiva" :key="'repact' + i" :class="{ btop: (i > 0) }">
                  <p class="datosOtros">{{ empresas.nombre.toUpperCase() }}</p>
                  <p class="datosOtros">{{ empresas.rfc.toUpperCase() }}</p>
                </div>
                <div v-if="intereses.reprActiva.length == 0">
                  <p class="datosOtros">NO</p>
                </div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div class="categoria padd">Clientes Principales</div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div v-for="(empresas, i) in intereses.clientesPrinc" :key="'client' + i" :class="{ btop: (i > 0) }">
                  <p class="datosOtros">{{ empresas.nombre.toUpperCase() }}</p>
                  <p class="datosOtros">{{ empresas.rfc.toUpperCase() }}</p>
                </div>
                <div v-if="intereses.clientesPrinc.length == 0">
                  <p class="datosOtros">NO</p>
                </div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div class="categoria padd">Beneficios Privados</div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div v-for="(empresas, i) in intereses.beneficiosPriv" :key="'int_bene' + i" :class="{ btop: (i > 0) }">
                  <p class="datosOtros">{{ empresas.nombre.toUpperCase() }}</p>
                  <p class="datosOtros">{{ empresas.rfc.toUpperCase() }}</p>
                </div>
                <div v-if="intereses.beneficiosPriv.length == 0">
                  <p class="datosOtros">NO</p>
                </div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div class="categoria padd">Fideicomisos</div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div v-for="(empresas, i) in intereses.fideicomisos" :key="'fidei' + i" :class="{ btop: (i > 0) }">
                  <p class="datosOtros">{{ empresas.nombre.toUpperCase() }}</p>
                  <p class="datosOtros">{{ empresas.rfc.toUpperCase() }}</p>
                </div>
                <div v-if="intereses.fideicomisos.length == 0">
                  <p class="datosOtros">NO</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row border-top">
          <div class="col">
            <div class="row border-top">
              <div class="col bk">
                <div class="categoria">Ingresos</div>
              </div>
            </div>
            <div style="margin-top: 12px;" v-if="ingresos">
              <div v-if="getKey('tipo_dec') == 'Inicial'">
                <div class="row border-top">
                  <div class="col">
                    <div class="categoria padd">Sueldos y salarios públicos (situación actual)</div>
                  </div>
                </div>
                <div class="row border-top">
                  <div class="col">
                    <div v-for="(sueldo, i) in ingresos.spublicos" :key="'spub' + i" :class="{ btop: (i > 0) }">
                      <p class="datosOtros">{{ sueldo.nombre }}</p>
                      <p class="datosOtros">${{ sueldo.ingreso | formatPrice }}</p>
                    </div>
                  </div>
                </div>
                <div class="row border-top">
                  <div class="col">
                    <div class="categoria padd">Otros sueldos y salarios (situación actual)</div>
                  </div>
                </div>
                <div class="row border-top">
                  <div class="col">
                    <div v-for="(sueldo, i) in ingresos.otros" :key="'otros' + i" :class="{ btop: (i > 0) }">
                      <p class="datosOtros">{{ sueldo.cat }}</p>
                      <p class="datosOtros">{{ sueldo.nombre }}</p>
                      <p class="datosOtros">${{ sueldo.ingreso | formatPrice }}</p>
                    </div>
                  </div>
                  <div v-if="ingresos.otros.length == 0">
                    <p class="datosOtros">NO</p>
                  </div>
                </div>
              </div>
              <div class="row border-top">
                <div class="col">
                  <div class="categoria padd">Sueldos y salarios públicos (año inmediato anterior)</div>
                </div>
              </div>
              <div class="row border-top">
                <div class="col">
                  <div v-for="(sueldo, i) in ingresos.spublicosant" :key="'spubant' + i" :class="{ btop: (i > 0) }">
                    <p class="datosOtros">{{ sueldo.nombre }}</p>
                    <p class="datosOtros">${{ sueldo.ingreso | formatPrice }}</p>
                  </div>
                </div>
              </div>
              <div class="row border-top">
                <div class="col">
                  <div class="categoria padd">Otros sueldos y salarios (año inmediato anterior)</div>
                </div>
              </div>
              <div class="row border-top">
                <div class="col">
                  <div v-for="(sueldo, i) in ingresos.otrosant" :key="'otrosant' + i" :class="{ btop: (i > 0) }">
                    <p class="datosOtros">{{ sueldo.cat }}</p>
                    <p class="datosOtros">{{ sueldo.nombre }}</p>
                    <p class="datosOtros">${{ sueldo.ingreso | formatPrice }}</p>
                  </div>
                </div>
                <div v-if="ingresos.otrosant.length == 0">
                  <p class="datosOtros">NO</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row border-top" v-if="simplificada != '1'">
          <div class="col">
            <div class="row border-top">
              <div class="col bk">
                <div class="categoria">Activos</div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div class="categoria padd">Bienes inmuebles</div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div v-for="(item, i) in activos.inmuebles" :key="'inmu' + i" :class="{ btop: (i > 0) }">
                  <p class="datosOtros">{{ item.tipoOperacion }}</p>
                  <p class="datosOtros">{{ item.naturaleza }}</p>
                  <p class="datosOtros">{{ item.domicilio }}</p>
                  <p class="datosOtros">${{ item.padquisicion | formatPrice }}</p>
                </div>
                <div v-if="activos.inmuebles.length == 0">
                  <p class="datosOtros">NO</p>
                </div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div class="categoria padd">Bienes muebles</div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div v-for="(item, i) in activos.bmuebles" :key="'bmueb' + i" :class="{ btop: (i > 0) }">
                  <p class="datosOtros">{{ item.tipoOperacion }}</p>
                  <p class="datosOtros">{{ item.tipoBien }}</p>
                  <p class="datosOtros">${{ item.padquisicion | formatPrice }}</p>
                </div>
                <div v-if="activos.bmuebles.length == 0">
                  <p class="datosOtros">NO</p>
                </div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div class="categoria padd">Bienes muebles no registrables</div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div v-for="(item, i) in activos.bmueblesnr" :key="'bmuesnr' + i" :class="{ btop: (i > 0) }">
                  <p class="datosOtros">{{ item.tipoOperacion }}</p>
                  <p class="datosOtros">{{ item.tipoBien }}</p>
                  <p class="datosOtros">${{ item.padquisicion | formatPrice }}</p>
                </div>
                <div v-if="activos.bmueblesnr.length == 0">
                  <p class="datosOtros">NO</p>
                </div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div class="categoria padd">Inversiones</div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div v-for="(item, i) in activos.inversiones" :key="'inver' + i" :class="{ btop: (i > 0) }">
                  <p class="datosOtros">{{ item.institucion }}</p>
                  <p class="datosOtros">${{ item.monto | formatPrice }}</p>
                </div>
                <div v-if="activos.inversiones.length == 0">
                  <p class="datosOtros">NO</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row border-top" v-if="simplificada != '1'">
          <div class="col">
            <div class="row border-top">
              <div class="col bk">
                <div class="categoria">Pasivos</div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div class="categoria padd">Adeudos</div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div v-for="(item, i) in pasivos.deudas" :key="'deudas' + i" :class="{ btop: (i > 0) }">
                  <p class="datosOtros">{{ item.identificador }}</p>
                  <p class="datosOtros">{{ item.acreedor }}</p>
                  <p class="datosOtros">${{ item.saldo | formatPrice }}</p>
                </div>
                <div v-if="pasivos.deudas.length == 0">
                  <p class="datosOtros">NO</p>
                </div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div class="categoria padd">Préstamo o Comodato</div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <div v-for="(item, i) in pasivos.prestamo" :key="'prestamo' + i" :class="{ btop: (i > 0) }">
                  <p class="datosOtros">{{ item.tipo }}</p>
                  <p class="datosOtros">{{ item.tipoBien }}</p>
                </div>
                <div v-if="pasivos.prestamo.length == 0">
                  <p class="datosOtros">NO</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row border-top">
          <div class="col">
            <div class="row border-top">
              <div class="col bk">
                <div class="categoria">Declaración fiscal</div>
              </div>
            </div>
            <div class="row border-top">
              <div class="col">
                <p class="datosOtros">{{ fiscal }}</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2 container-fluid">
        <div class="card">
          <div class="card-content text-center alert-warning">
            <h3>Estás a punto de enviar la declaración {{ this.getKey('tipo_dec').toLowerCase() }}, una vez enviada, no podrás editar los datos</h3>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-md-offset-3 container-fluid text-center">
        <button refs="btnEnviar" type="button" class="btn btn-wd btn-success" @click="openManifiesto" :disabled="enviando">
          <span class="btn-label">
            <i class="fa fa-check"></i>
          </span>
          Enviar
        </button>
        <br><br><br><br>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import Manifiesto from '@/components/Manifiesto.component.vue'
import {
  Table,
  TableColumn
} from 'element-ui'
Vue.use(Table)
Vue.use(TableColumn)
export default {
  components: {},
  data () {
    return {
      simplificada: '',
      ip_id: null,
      fecha: '',
      hora: '',
      enviando: false,
      texto: 'Enviando Declaración',
      close: false,
      dpersonales: {
        nombres: ''
      },
      encargo: {
        dependencia: '',
        cargo: ''
      },
      intereses: {
        empresas: [],
        tomaDecisiones: [],
        beneficiosPubl: [],
        reprActiva: [],
        clientesPrinc: [],
        beneficiosPriv: [],
        fideicomisos: []
      },
      pasivos: {
        deudas: [],
        prestamo: []
      },
      curriculares: {},
      experiencia: {},
      ingresos: null,
      activos: {
        inmuebles: [],
        bmuebles: [],
        bmueblesnr: [],
        inversiones: []
      },
      sueldos: null,
      fiscal: null,
      dependientes: []
    }
  },
  created () {
    this.simplificada = this.getKey('simplificada')
    // if (this.simplificada == '1') {
    this.checkPermissions()
    this.ip_id = this.getId()
    this.fechaHora()
    this.getResumen()
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    formatPrice: function (value) {
      let val = (value / 1).toFixed(2).replace('.', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    checkPermissions () {
      if (!(this.getKey('role') == 0 && this.getKey('status_dec') == 1)) {
        localStorage.clear()
        this.$router.push('/login')
        this.$router.go()
      }
    },
    fechaHora () {
      var fecha = new Date()
      var options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long'
      }
      var options2 = {
        hour: 'numeric',
        minute: 'numeric'
      }


      this.fecha = fecha.toLocaleDateString('es-ES', options)
      this.hora = fecha.getHours() + ':' + fecha.getMinutes() + ' hrs'
    },
    getResumen () {
      this.$http.get('getResumen/' + this.ip_id).then(
        response => {
          this.dpersonales = response.data.resumen.dpersonales
          this.encargo = response.data.resumen.dencargo
          this.dependientes = response.data.resumen.dependientes
          this.intereses = response.data.resumen.intereses
          this.ingresos = response.data.resumen.ingresos
          this.activos = response.data.resumen.activos
          this.pasivos = response.data.resumen.pasivos
          this.fiscal = response.data.resumen.fiscal
          this.experiencia = response.data.resumen.experiencia
          this.curriculares = response.data.resumen.curriculares

          if (!this.activos.bmueblesnr) {
            this.activos.bmueblesnr = []
          }
        },
        error => {
          this.StepError(error)
          // console.log(error);
        })
    },
    openManifiesto (item) {
      // this.enviar()
      this.modalTitle = '<h5><b>Manifiesto para publicación de Declaración patrimonial</b></h5>'
      this.modalComponent = { ...Manifiesto }
      this.modalData = this.dpersonales
      this.modalSize = 'modal-xl'
      this.Modal('#modal-manifiesto')
    },
    enviar (e) {
      $('#modal-manifiesto').modal('hide')
      let autorizacion = e.autorizacion
      let msg = 'Se autorizó a la Secretaría de la Transparencia y Rendición de Cuentas generar la versión pública de su declaración patrimonial y de intereses, para efecto de que la misma sea pública.'
      if (!autorizacion) {
        msg = 'Se negó la autorización a la Secretaría de la Transparencia y Rendición de Cuentas para hacer pública su declaración patrimonial y de intereses.'
      }
      // this.Ask3('Esta apunto de enviar su declaración ' + this.getKey('tipo_dec').toLowerCase() + '  ' + this.getKey('periodo') + ', ¿Desea continuar?',
      //   // 'Manifiesto para publicación de Declaración patrimonial',
      //   Manifiesto,
      //   'Autorizo', 'No Autorizo', (autorizacion) => {
      this.Ask('Esta apunto de enviar su declaración ' + this.getKey('tipo_dec').toLowerCase() + '  ' + this.getKey('periodo') + '. <br><hr style="height: 1px !important; background: #C8C5C2;"><b>' + msg + '</b>',
      () => {
        let cargando = this.$swal({
          showConfirmButton: false,
          type: 'info',
          title: this.texto,
        // text: 'No cierre la ventana, se le redireccionará automáticamente',
          html: '<p><hr style="height: 1px !important; background: #C8C5C2;"><b>No cierre la ventana, se le redireccionará automáticamente</b> </p>',
          showCloseButton: this.close
        })

        this.enviando = true

        var params = {
          params: {
            ip_id: this.ip_id,
            p: autorizacion // publica
          }
        }
        this.$http.get('savedeclaracion', params).then(
        response => {
          if (response.data.data == 'Correcto') {
            setTimeout(() => {
              this.setSession(response.data)
              this.$router.push('enviada')
              this.$router.go()
            }, 5000)
          } else { this.Err(response.data) }
        },
        error => {
          this.enviando = false
          console.log(error)
          this.Err(error)
        })
      }, 'Enviar')
    }
  }
}

</script>
<style>
.bk {
  background: #F7F7F7;
}

.btop {
  margin-top: 12px;
  /* margin-bottom: 12px; */
  padding-top: 12px;
  /* padding-bottom: 12px; */
  border-top: 1px solid #eaeaea !important;
  /* border-bottom: 1px solid #eaeaea !important; */
}

.mytable td {
  padding: 0.75rem !important;
  vertical-align: middle;
  border-top: 1px solid #CCC5B9;
}

img.resize {
  max-width: 40% !important;
  max-height: 40% !important;
}

/* thead {
    display: none;
  } */

.nombreUpc {
  text-transform: uppercase;
  text-align: left !important;
}

.categoria {
  font-weight: bold !important;
}

.ing {
  background-color: transparent !important;
  width: 100%;
  display: table;
}

.datosOtros {
  margin-block-start: 0px !important;
  margin-block-end: 0px !important;
  padding-left: 15px !important;
  text-align: left !important;

}

.fechap::first-letter {
  text-transform: uppercase;
}

.fechap {
  font-weight: bold;
}

.padd {
  padding-left: 15px;
}

.padd:nth-child(2n) {
  border-top: 1px solid #CCC5B9;
  border-bottom: 1px solid #CCC5B9;
  margin-top: 8px !important;
  margin-bottom: 8px !important;
  padding-top: 8px;
  padding-bottom: 8px;
}


.grisbck {
  background-color: #FFFFFA !important;
}

.my-actions {
  margin: .5em 2em !important;

}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.right-gap {
  margin-right: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Resumen.vue